export default __webpack_public_path__ + "static/media/fish.6423f1dd.svg";